import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("@/views/HomeView.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/LoginView.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/auth/callback",
      name: "AuthCallback",
      component: () => import("@/views/AuthCallbackView.vue"),
      meta: { requiresGuest: true },
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: () => import("@/views/DashboardView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/scripts",
      name: "Scripts",
      component: () => import("@/views/ScriptsView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/billing",
      name: "Billing",
      component: () => import("@/views/BillingView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/licenses",
      name: "Licenses",
      component: () => import("@/views/LicensesView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/snapshots",
      name: "Snapshots",
      component: () => import("@/views/SnapshotsView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/access-keys",
      name: "AccessKeys",
      component: () => import("@/views/AccessKeysView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/settings",
      name: "Settings",
      component: () => import("@/views/SettingsView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/docs",
      name: "Docs",
      component: () => import("@/views/DocsView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/:pathMatch(.*)*",
      name: "NotFound",
      component: () => import("@/views/NotFoundView.vue"),
    },
  ],
});

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore();

  // Aguardar inicialização da autenticação
  if (!authStore.isInitialized) {
    await authStore.initAuth();
  }

  const requiresAuth = to.meta.requiresAuth;
  const requiresGuest = to.meta.requiresGuest;
  const isAuthenticated = authStore.isAuthenticated;

  if (requiresAuth && !isAuthenticated) {
    next("/login");
  } else if (requiresGuest && isAuthenticated) {
    next("/dashboard");
  } else {
    next();
  }
});

export default router;
